import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconInfo = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconInfo.dimensions.width} ${IconInfo.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        fillRule="evenodd"
        d="M3.04 2.54a7.72 7.72 0 1 1 10.92 10.92A7.72 7.72 0 0 1 3.04 2.54ZM8.5 1.28a6.72 6.72 0 1 0 0 13.44 6.72 6.72 0 0 0 0-13.44Zm0 6.22A.5.5 0 0 1 9 8v3.61a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Zm-.321-3.199a.76.76 0 1 1 .844 1.263.76.76 0 0 1-.844-1.263Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}

IconInfo.dimensions = {
  width: 17,
  height: 16,
}

export default IconInfo
